module.exports = __webpack_public_path__ + "static/img/40.f450605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/40.jpg
// module id = S3mG
// module chunks = 0